export const NMO_MESSAGE_PIPELINE_KEY_1 = 'nmo_message_pipeline_xRTb4MSc';
export const NMO_MESSAGE_PIPELINE_KEY_2 = 'nmo_pipeline_nSqkFF26';
